import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { sheet } from './sheet'
import { Classes } from 'jss'
import LogoMenu from 'components/svgComponent/LogoMenu'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'

type Props = RouteComponentProps & {
  classes: Classes
}

class DeleteAccount extends Component<Props> {
  render() {
    const { classes, history } = this.props

    return (
      <div className={classes.main}>
        <div className={classes.navBar}>
          <LogoMenu onClick={() => history.push('/')} />
        </div>

        <div className={classes.root}>
          <h1>Delete Account &amp; Data Removal</h1>
          <p>
            At <strong>Skilent</strong>, we respect your privacy and provide clear options to remove
            your account and associated data. This page explains how to request deletion, what is
            removed, what may be retained, and applicable timelines.
          </p>

          <h3>How to request account deletion</h3>
          <ol>
            <li>
              Send an email to <a href="mailto:support@skilent.com">support@skilent.com</a> from the
              email address linked to your account.
            </li>
            <li>
              Use the subject line: <strong>"Request to Delete Account"</strong>.
            </li>
            <li>
              Optionally include any additional identifiers (e.g., your user ID) to help us locate
              your account faster.
            </li>
            <li>Our support team will verify your identity and confirm the deletion process.</li>
          </ol>

          <h3>What will be deleted</h3>
          <ul>
            <li>Your account and profile information (e.g., name, email, profile details).</li>
            <li>Uploaded documents and media (e.g., resumes, certifications, attachments).</li>
            <li>Job application history and saved preferences associated with your account.</li>
            <li>Active sessions and authentication tokens.</li>
          </ul>

          <h3>What may be retained (temporarily)</h3>
          <p>
            We may retain minimal records as required by law or for legitimate business purposes
            (e.g., fraud prevention, security logs, audit trails). Such records, if retained, are
            stored securely and deleted automatically within <strong>90 days</strong>. Retained
            items, if any, are not used to identify you for product features after your account is
            deleted.
          </p>

          <h3>Timeline</h3>
          <ul>
            <li>We start processing your request once your identity is verified.</li>
            <li>
              Account and associated data are typically deleted within <strong>30 days</strong>.
            </li>
            <li>
              Any legally required retention records are removed within <strong>90 days</strong>.
            </li>
          </ul>

          <h3>Important notes</h3>
          <ul>
            <li>
              Deletion is <strong>permanent</strong> and cannot be undone.
            </li>
            <li>
              If you only want to stop receiving notifications, you can update your preferences
              instead of deleting your account.
            </li>
            <li>
              If you reinstall or sign in again after deletion is complete, a new account will be
              created.
            </li>
          </ul>

          <h3>Delete specific data without deleting the account</h3>
          <p>
            If you want to remove specific documents or profile fields without deleting your entire
            account, please contact <a href="mailto:support@skilent.com">support@skilent.com</a>{' '}
            with details of the data you wish to remove. We’ll guide you through available options.
          </p>

          <h3>Contact</h3>
          <p>
            For any questions regarding account or data deletion, contact us at{' '}
            <a href="mailto:support@skilent.com">support@skilent.com</a>.
          </p>

          <p style={{ opacity: 0.7, marginTop: 24 }}>
            Last updated: {new Date().toISOString().split('T')[0]}
          </p>
        </div>
      </div>
    )
  }
}

export default withRouter(injectSheet(sheet)(DeleteAccount))
